import { motion } from "framer-motion";
import type { AuthFieldProps } from "../auth.types";

interface AuthFieldSectionProps extends AuthFieldProps {
  animationIndex?: number;
}

export const AuthFieldSection = ({
  icon,
  title,
  description,
  children,
  animationIndex = 0,
}: AuthFieldSectionProps) => {
  return (
    <motion.div
      className="flex flex-col gap-3"
      custom={animationIndex}
      variants={{
        hidden: { opacity: 0, y: 16 },
        visible: (i: number) => ({
          opacity: 1,
          y: 0,
          transition: {
            delay: 0.3 + i * 0.1,
            duration: 0.5,
            ease: "easeOut",
          },
        }),
      }}
      initial="hidden"
      animate="visible"
    >
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-2">
          <span className="text-white flex items-center" aria-hidden="true">
            {icon}
          </span>
          <h3 className="text-white text-[1.125rem] font-semibold leading-none">
            {title}
          </h3>
        </div>
        <p className="text-white/50 text-[0.813rem] leading-[1.5]">
          {description}
        </p>
      </div>
      {children}
    </motion.div>
  );
};
